// Optionally, map types to icons/colors
import {
  MailOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserSwitchOutlined,
  FileDoneOutlined,
  StarOutlined,
  TrophyOutlined,
  MessageOutlined,
} from "@ant-design/icons";


export enum NotificationType {
    APPLICATION_RECEIVED = "application_received",
    INVITATION_ACCEPTED = "invitation_accepted",
    INVITATION_REJECTED = "invitation_rejected",
    MANAGER_ACTION = "manager_action",
    OFFER_PLACED = "offer_placed",
    OFFER_ACCEPTED = "offer_accepted",
    OFFER_REJECTED = "offer_rejected",
    SHORTLISTED_BY_RECRUITER = "shortlisted_by_recruiter",
    SHORTLISTED_BY_MANAGER = "shortlisted_by_manager",
    APPLICATION_SUBMITTED_TO_MANAGER = "application_submitted_to_manager",
    REJECTED_BY_MANAGER = "rejected_by_manager",
    APPLICATION_WITHDRAWN = "application_withdrawn",
    HIRED = "hired",
    CHAT_MESSAGE = "chat_message",
    
    // ...add more as needed
  }
export const notificationTypeMeta = {
  [NotificationType.APPLICATION_RECEIVED]: {
    icon: null,
    color: "#1890ff",
    label: "New Application",
  },
  [NotificationType.INVITATION_ACCEPTED]: {
    icon: null,
    color: "#52c41a",
    label: "Invitation Accepted",
  },
  [NotificationType.INVITATION_REJECTED]: {
    icon: null,
    color: "#ff4d4f",
    label: "Invitation Rejected",
  },
  [NotificationType.MANAGER_ACTION]: {
    icon: null,
    color: "#faad14",
    label: "Manager Action",
  },
  [NotificationType.APPLICATION_SUBMITTED_TO_MANAGER]: {
    icon: MailOutlined,
    color: '#1890ff',
    label: 'Application Submitted to Manager',
  },
  [NotificationType.REJECTED_BY_MANAGER]: {
    icon: CloseCircleOutlined,
    color: '#ff4d4f',
    label: 'Rejected by Manager',
  },
  [NotificationType.OFFER_PLACED]: {
    icon: FileDoneOutlined,
    color: '#722ed1',
    label: 'Offer Placed',
  },
  [NotificationType.OFFER_ACCEPTED]: {
    icon: CheckCircleOutlined,
    color: '#52c41a',
    label: 'Offer Accepted',
  },
  [NotificationType.OFFER_REJECTED]: {
    icon: CloseCircleOutlined,
    color: '#ff4d4f',
    label: 'Offer Rejected',
  },
  [NotificationType.APPLICATION_WITHDRAWN]: {
    icon: MailOutlined,
    color: '#faad14',
    label: 'Application Withdrawn',
  },
  [NotificationType.SHORTLISTED_BY_RECRUITER]: {
    icon: StarOutlined,
    color: '#faad14',
    label: 'Shortlisted by Recruiter',
  },
  [NotificationType.SHORTLISTED_BY_MANAGER]: {
    icon: TrophyOutlined,
    color: '#722ed1',
    label: 'Shortlisted by Manager',
  },
  [NotificationType.HIRED]: {
    icon: TrophyOutlined,
    color: '#52c41a',
    label: 'Hired',
  },
  [NotificationType.CHAT_MESSAGE]: {
    icon: MessageOutlined,
    color: '#1890ff',
    label: 'New Message',
  },
  // ...add more as needed
};
